var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('icon-button',{attrs:{"size":"1rem","color":"accent","icon":"far-arrow-right-from-bracket"},on:{"click":_vm.onClick}},[_vm._v(" Cerrar sesión ")])
}
var staticRenderFns = []

export { render, staticRenderFns }